import React, { useState } from "react";
import axios from "axios";
import "./PreFooterForm.css";

const PreFooterForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    type: "",
    message: "",
    date: new Date().toISOString().split("T")[0], // Current date
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "https://api.dremerz.net/api/Project_17_ManPowerWebsite_feedback_Aplication_Form",
        formData
      );
      alert("Message sent successfully!");
      setFormData({
        name: "",
        mobile: "",
        email: "",
        type: "",
        message: "",
      });
    } catch (error) {
      console.error("Error sending message:", error);
      alert("Failed to send message. Please try again.");
    }
  };
  return (
    <div className="container ContactPageForm-container py-5">
      <div className="row align-items-center">
        {/* Left Side - Contact Information */}
        <div className="col-md-6 mb-4">
          <button className="ContactPageForm-contactBtn">
            Contact Us <span className="arrow">→</span>
          </button>
          <h2 className="ContactPageForm-title">Hire us & get in touch</h2>
          <p className="ContactPageForm-description">
            We are dedicated to providing compassionate, high-quality care that
            enhances the lives of our residents.
          </p>

          <div className="row">
            <div className="col-12">
              <div className="ContactPageForm-infoBox">
                <i className="fa fa-phone"></i>
                <h5>Monday to Saturday - 9:00 AM to 6:00 PM</h5>
                <p>
                  <a
                    href="tel:+919840562357"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    +91 98400 88046
                  </a>
                </p>
                <p>(closed on public holidays)</p>
              </div>
            </div>
            <div className="col-12">
              <div className="ContactPageForm-infoBox">
                <i className="fa fa-envelope"></i>
                <h5>Email Us</h5>
                <p>Smcmanpowerconsultancy@gmail.com</p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Feedback Form */}
        <div className="col-md-6 mt-5">
          <div className="ContactPageForm-formBox">
            <h3 className="ContactPageForm-formTitle">Get in Touch</h3>
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Your Name*"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Mobile Number*"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Email Address*"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <select
                    className="form-control"
                    name="type"
                    value={formData.type}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Choose types of ...</option>
                    <option value="Care Taker at Home">
                      Care Taker at Home
                    </option>
                    <option value="Elder Care / Senior Citizen Care at Home">
                      Elder Care / Senior Citizen Care at Home
                    </option>
                    <option value="Bed Ridden Care at Home">
                      Bed Ridden Care at Home
                    </option>
                    <option value="All Injections at Home">
                      All Injections at Home
                    </option>
                    <option value="Wound Dressing at Home">
                      Wound Dressing at Home
                    </option>
                    <option value="Cancer Care at Home">
                      Cancer Care at Home
                    </option>
                    <option value="Post Surgical Care at Home">
                      Post Surgical Care at Home
                    </option>
                    <option value="Catheter Care at Home">
                      Catheter Care at Home
                    </option>
                    <option value="Tracheostomy Care at Home">
                      Tracheostomy Care at Home
                    </option>
                    <option value="Psychiatric Care at Home">
                      Psychiatric Care at Home
                    </option>
                    <option value="Stroke Care at Home">
                      Stroke Care at Home
                    </option>
                    <option value="Physiotherapy at Home">
                      Physiotherapy at Home
                    </option>
                    <option value="Lab Tests at Home">Lab Tests at Home</option>
                    <option value="Ambulance with O2- AC/Non AC">
                      Ambulance with O2- AC/Non AC
                    </option>
                    <option value="Medical Equipment - Sales/Rental">
                      Medical Equipment - Sales/Rental
                    </option>
                  </select>
                </div>
                <div className="col-12 mb-3">
                  <textarea
                    className="form-control"
                    placeholder="Additional Message"
                    rows="3"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>
                <div className="col-12">
                  <button className="ContactPageForm-submitBtn" type="submit">
                    SEND MESSAGE <i className="fa fa-paper-plane"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreFooterForm;
